import React from 'react';
import useForm from 'hooks/useLocalizedSimpleForm';
import { PushValidators } from 'validators/ExperienceCanvas/push.validator';
import { isUrlValid } from 'validators/ExperienceCanvas/common.validator';
import { PushFormClassPrefix as CLASS_PREFIX } from 'components/ExperienceCanvas/constants';
import { FlightCheckbox, FlightTextInput } from '@flybits/design-system';
import { PushDraft, PushDraftCallbacks } from '../pushDraft.types';

type WeblinkFormProps = Pick<PushDraftCallbacks, 'onChangePushField'> & {
  pushDraft: PushDraft;
  activeLang: string;
  defaultLang: string;
};

const WeblinkForm = ({ pushDraft, activeLang, defaultLang, onChangePushField }: WeblinkFormProps) => {
  const urlInDraft = pushDraft.url?.[activeLang];

  const {
    formData: payloadData,
    updateField,
    toggleError,
  } = useForm({
    data: {
      url: { value: urlInDraft ?? '' },
      allowNonHttps: { value: !urlInDraft || isUrlValid(urlInDraft) ? false : true },
    },
    validators: PushValidators,
    lang: activeLang,
    defaultLang,
  });

  const handleBlur = () => {
    toggleError('url');
    onChangePushField('url', activeLang, payloadData.url.value);
  };

  const onClickUrlBox = () => {
    const currentValue = payloadData.allowNonHttps.value;

    updateField('allowNonHttps', !currentValue);
    toggleError('url');
  };

  return (
    <div className={`${CLASS_PREFIX}__container`}>
      <FlightTextInput
        label={'Weblink URL'}
        hasError={payloadData.url.showError}
        errorMessage={payloadData.url.error}
        value={payloadData.url.value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => updateField('url', e.target.value)}
        onBlur={() => {
          handleBlur();
        }}
        width="100%"
      />
      <div className={`${CLASS_PREFIX}__row`}>
        <div className={`${CLASS_PREFIX}__label`}>
          <p className={`${CLASS_PREFIX}__label-primary`}>Allow non-https or custom URL</p>
          <p className={`${CLASS_PREFIX}__label-secondary`}>
            Please ensure that your app can parse the URL appropriately
          </p>
        </div>
        <FlightCheckbox
          className={`${CLASS_PREFIX}__right`}
          checkState={payloadData.allowNonHttps.value ? 'SELECTED' : 'UNSELECTED'}
          onSelect={onClickUrlBox}
        />
      </div>
    </div>
  );
};

export default WeblinkForm;
